import type { ComponentsDefinition } from '@eneco/cms';
import { cmsComponents } from '@eneco/cms-components';
import dynamic from 'next/dynamic';

/**
 * The CMS-agnostic registry for this container: the shared one plus what only this
 * container mounts.
 *
 * Applications are registered per container on the Sitecore lane too, in
 * `sitecoreComponents.ts`, and for the same reason: they cannot live in the shared
 * registry. `lib:cms-components` may not depend on `app:next` (see `depConstraints`
 * in `eslint.config.mjs`), and every container passes that one map, so a flow put
 * there would also be pulled into the containers that never render it.
 *
 * The cookie wall is one of those applications. It sits in the page's `jss-meta`
 * placeholder, which `CmsLayout` renders on this lane too, and reads its content
 * through `@eneco/cms`, so the same component serves both lanes.
 *
 * `Unsubscribe` is registered for the same reason, and reads its content
 * through `@eneco/cms` too.
 *
 * No flow is here yet. The flows in `sitecoreComponents.ts` still read Sitecore directly,
 * so mounting them on this lane would fail at the first step rather than render. Each is
 * added as it migrates.
 */
const components: ComponentsDefinition = {
  ...cmsComponents,
  CookieWall: dynamic(() => import('@apps/cookiewall-nl-multilabel/CookieWall')),
  Unsubscribe: dynamic(() => import('@apps/unsubscribe-shared-multilabel/Unsubscribe')),
};

export default components;
